import { render } from "./EnfermeroLayout.vue?vue&type=template&id=71d16a7a&scoped=true"
import script from "./EnfermeroLayout.vue?vue&type=script&lang=js"
export * from "./EnfermeroLayout.vue?vue&type=script&lang=js"

import "./EnfermeroLayout.vue?vue&type=style&index=0&id=71d16a7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d16a7a"]])

export default __exports__